<template>
  <div>
    <div @click="openAdd">
      <div
        class="book-mark-card-simple flex-center"
        v-if="this.markMode === 'SIMPLE'"
      >
        <div class="flex-center">
          <div class="card-img-simple">
            <img src="../../assets/img/add.png" />
          </div>
          <div class="card-title-simple label-add text-label-gray">
            新增书签
          </div>
        </div>
      </div>
      <div class="book-mark-card-basic" v-else>
        <div class="flex-center add-content">
          <div class="card-img-simple">
            <img src="../../assets/img/add.png" />
          </div>
          <div class="card-title-simple label-add text-label-gray">
            新增书签
          </div>
        </div>
      </div>
    </div>
    <div class="modelArea">
      <div id="edit-bookmark">
        <a-modal
          v-model="bookmarkEditVisible"
          title="书签信息"
          @ok="saveBookmark"
          centered
          okText="保存"
          cancelText="关闭"
        >
          <a-form
            :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 14 }"
            @submit="saveBookmark"
          >
            <a-form-item label="书签地址：">
              <a-input
                v-decorator="[
                  'url',
                  {
                    initialValue: bookMarkInfo.url,
                    rules: [
                      { required: true, message: '请输入书签地址!' },
                      { type: 'url', message: '请输入正确格式的网址！' },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="书签名称">
              <a-input
                v-decorator="[
                  'name',
                  {
                    initialValue: bookMarkInfo.name,
                    rules: [{ required: true, message: '请输入书签名称!' }],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="快捷指令">
              <a-input
                v-decorator="[
                  'shortcut',
                  {
                    initialValue: bookMarkInfo.shortcut,
                  },
                ]"
              >
                <a-tooltip
                  slot="suffix"
                  title="使用Ctrl+Q按键呼出快捷指令输入口，再输入此指令可以快速打开此链接！"
                >
                  <a-icon
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>
              </a-input>
            </a-form-item>
            <a-form-item label="书签分类">
              <a-input
                disabled
                v-decorator="[
                  'categoryName',
                  {
                    initialValue: currentCategory.name,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="书签ID" hidden>
              <a-input
                disabled
                v-decorator="[
                  'categoryId',
                  {
                    initialValue: currentCategory.id,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="描述">
              <a-textarea
                placeholder="网站备注"
                :auto-size="{ minRows: 2, maxRows: 5 }"
                v-decorator="[
                  'description',
                  {
                    initialValue: bookMarkInfo.description,
                  },
                ]"
              />
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bookmarkEditVisible: false,
      bookMarkInfo: {},
      form: this.$form.createForm(this, { name: "coordinated" }),
    };
  },
  props: ["markMode", "currentCategory"],
  methods: {
    openAdd() {
      if (!this.currentCategory.id) {
        this.$message.warn("请点击左侧选择一个分类!");
      } else {
        this.bookmarkEditVisible = true;
      }
    },
    saveBookmark(e) {
      let that = this;
      e.preventDefault();
      this.form.validateFields((result, formData) => {
        if (!result) {
          this.$req.post("/api/favorites/save", formData, (res) => {
            that.bookmarkEditVisible = false;
            this.$message.success("保存成功！");
            this.form.resetFields();
            this.$emit('success');
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.label-add {
  margin-left: 10px;
  margin-top: 5px;
}
.add-content {
  margin-top: 20px;
}
.book-mark-card-basic:hover {
  box-shadow: 0 4px 16px 0 rgba(0,0,0,.1);
  cursor: pointer;
}
.book-mark-card-simple:hover{
  box-shadow: 0 4px 16px 0 rgba(0,0,0,.1);
  cursor: pointer;
}
</style>